export enum EnergyOrderedConfirmation {
    Ots = 'ots',
    Assisted = 'assisted',
    Pending = 'pending',
    Lost = 'lost',
}
